export default __webpack_public_path__ + "static/media/calender.ad55cab0.svg";